module.exports = __webpack_public_path__ + "prod/1.42.2/img/bankeys-goods.de380c1e.png";